export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/061aa53740bb9677.jpg"